var map = {
	"./bmwicon-动作.svg": "f45b",
	"./bmwicon-回应.svg": "6c2e",
	"./bmwicon-屏幕分享.svg": "8e73",
	"./bmwicon-屏幕分享关闭.svg": "6bb3",
	"./bmwicon-提问.svg": "30eb",
	"./bmwicon-摄像头.svg": "b9d2",
	"./bmwicon-摄像头关闭.svg": "98b1",
	"./bmwicon-汽车动画.svg": "9ea4",
	"./bmwicon-电影.svg": "ea8e",
	"./bmwicon-聊天.svg": "7a9d",
	"./bmwicon-视角锁定.svg": "bb6d",
	"./bmwicon-语音.svg": "56ac",
	"./bmwicon-语音关闭.svg": "5f6f",
	"./bmwicon-鼓掌.svg": "57b8",
	"./bmwicon_back.svg": "9810",
	"./bmwicon_personal.svg": "0142",
	"./bmwicon_举手.svg": "27e7",
	"./bmwicon_令牌.svg": "b190",
	"./bmwicon_传送.svg": "4092",
	"./bmwicon_净化ui.svg": "fb3f",
	"./bmwicon_列表.svg": "7953",
	"./bmwicon_动作.svg": "ad80",
	"./bmwicon_双车展示.svg": "3c60",
	"./bmwicon_地图.svg": "f8f8",
	"./bmwicon_屏幕共享.svg": "3258",
	"./bmwicon_弹幕.svg": "cec5",
	"./bmwicon_拍照.svg": "c207",
	"./bmwicon_提问.svg": "a1d1",
	"./bmwicon_摄像头.svg": "ae94",
	"./bmwicon_播放视频.svg": "8d69",
	"./bmwicon_数字人.svg": "c1e8",
	"./bmwicon_更换车辆.svg": "7894",
	"./bmwicon_点点点.svg": "5879",
	"./bmwicon_点赞.svg": "be4a",
	"./bmwicon_点赞非.svg": "b87a",
	"./bmwicon_禁用屏幕共享.svg": "f49e",
	"./bmwicon_禁用摄像头.svg": "8730",
	"./bmwicon_禁用语音.svg": "dbcd",
	"./bmwicon_视角.svg": "410f",
	"./bmwicon_视角锁.svg": "e859",
	"./bmwicon_语音.svg": "682a",
	"./bmwicon_贴花.svg": "da88",
	"./bmwicon_起立.svg": "543f",
	"./bmwicon_车动画.svg": "1911",
	"./bmwicon_车漆-26.svg": "65fa",
	"./bmwicon_车漆-27.svg": "a69a",
	"./bmwicon_退出.svg": "23ae",
	"./bmwicon_邀请-20.svg": "02e3",
	"./bmwicon_邀请-30.svg": "4ba0",
	"./bmwicon_邀请1.svg": "8d02",
	"./bmwicon_销售带看.svg": "c29d",
	"./bmwicon_鼓掌.svg": "5061"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1eef";